import { useState } from "react";
import { Link } from "../lib/router";
import { shortAddress } from "../lib/format";
import { useWallet } from "../lib/WalletContext";
import { LogoMark } from "./LogoMark";

const links = [
  ["/launch", "Launch"],
  ["/portfolio", "Portfolio"],
  ["/docs", "Docs"]
] as const;

export function Header({ pathname, onLaunch }: { pathname: string; onLaunch(): void }) {
  const wallet = useWallet();
  const [menu, setMenu] = useState(false);
  return (
    <header className="site-header">
      <Link href="/" className="brand-link" aria-label="Bubble Hood home"><LogoMark /></Link>
      <button className="menu-button" type="button" aria-expanded={menu} onClick={() => setMenu(!menu)}>
        <span /><span />
        <span className="sr-only">Toggle navigation</span>
      </button>
      <nav className={menu ? "site-nav is-open" : "site-nav"} aria-label="Primary navigation">
        {links.map(([href, label], index) => href === "/launch" ? (
          <button
            key={href}
            type="button"
            aria-label={label}
            data-index={`0${index + 1}`}
            className={pathname === href ? "is-active" : ""}
            onClick={() => { setMenu(false); onLaunch(); }}
          >
            <span>{label}</span>
          </button>
        ) : (
          <Link
            key={href}
            href={href}
            aria-label={label}
            data-index={`0${index + 1}`}
            className={pathname === href ? "is-active" : ""}
            onClick={() => setMenu(false)}
          >
            <span>{label}</span>
          </Link>
        ))}
      </nav>
      <div className="header-actions">
        <span className={wallet.wrongNetwork ? "network-pill is-wrong" : "network-pill"}><i /> {wallet.wrongNetwork ? "Switch network" : "Robinhood Chain"}</span>
        <button className="wallet-button" type="button" onClick={wallet.openPanel}>
          {wallet.address ? shortAddress(wallet.address) : "Connect wallet"}
        </button>
      </div>
    </header>
  );
}
